import { render, staticRenderFns } from "./loppukeskustelu-card.vue?vue&type=template&id=407ae11e&"
import script from "./loppukeskustelu-card.vue?vue&type=script&lang=ts&"
export * from "./loppukeskustelu-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports